module.exports = __webpack_public_path__ + "img/ddzg.cdcaa4c0.gif";